// test597
(597 && 0);
